<template>
  <div class="glpi-fila">
    <div>
      <PageTitle
        isBack="true"
        link="home"
        fontSize="25"
        icon="fa fa-line-chart"
        title="GLPI // Fila Geral de Chamados"
      />
    </div>
    <!-- filtros da lista -->
    <div class="container-glpi">
      <div class="filter-glpi">
        <vs-button
          radius
          color="primary"
          style="margin-top:20px; margin-right: 22px"
          size="small"
          type="border"
          icon="clear"
          @click="ClickClear"
        ></vs-button>
        <div class="group-name">
          <span>GLPI</span>
          <input
            type="text"
            style="width: 110px;height: 49px;"
            class="input-filter"
            autocomplete="off"
            v-model="glpi"
          />
        </div>
        <div class="group-name">
          <span>Requerente</span>
          <input
            type="text"
            icon="search"
            autocomplete="off"
            class="input-filter"
            style="height: 49px;"
            v-model="requerente"
          />
        </div>
        <div class="group-name">
          <span>Etapa</span>
          <b-form-select
            style="width: 200px; height: 50px;  margin-right: 3px"
            placeholder="Etapa"
            :options="rowTypeData"
            v-model="step"
          ></b-form-select>
        </div>
        <div>
          <span>Desenvolvedor</span>
          <b-form-select
            style="height: 50px;  margin-right: 5px"
            :options="workerData"
            v-model="developer"
          ></b-form-select>
        </div>
        <div class="group-search">
          <span>Grupo requerente</span>
          <div class="form-input">
            <input
              type="text"
              @focus="onFocusGroup"
              class="input-search-group"
              placeholder="Pesquise o grupo"
              v-model="valueGroup"
            />
            <i
              v-if="!visibleGroup"
              style="margin-top: 5px !important; margin-right: 30px !important"
              class="fa fa-sort-desc icon-group"
              @click="clickCloseGroup"
            ></i>
            <i v-else class="fa fa-sort-asc icon-group" @click="clickCloseGroup"></i>
          </div>

          <ul id="search-ul" v-show="visibleGroup">
            <li v-for="(item,index) in filterList" :key="index" @click="clickItemGroup(item)">
              <span v-html="item.name"></span>
            </li>
          </ul>
        </div>
        <button class="btn-search-glpi-client" type="filled" @click="clickSearch">Pesquisar</button>
      </div>

      <!-- loading -->
      <div style="text-align: center" v-if="loading">
        <img src="@/assets/load-action.gif" alt="loading" />
      </div>
      <!-- fim -->
      <!-- totais de chamados -->
      <div class="total-itens">
        <span>
          Total de chamados listados:
          <b>{{totalGlpiListed}}</b>
        </span>
        <span>
          Total de chamados da Engenharia de Software:
          <b>{{totalGeral}}</b>
        </span>
      </div>
      <!-- fim -->

      <div v-for="(ticket, index) in ticketData" :key="index">
        <vs-card
          actionable
          class="cardx card-custom-glpi"
          :style="'border-left: 120px solid ' + ticket.priorityColor"
          v-if="ticket.isVisible == 1"
        >
          <div class="card-custom-container">
            <div class="card-count">{{ index + 1 }}</div>
            <div class="user-profile">
              <vs-avatar size="45px" />
              <span>{{ ticket.login }}</span>
              <div class="priority">
                <span style="font-weight: bold;">Prioridade</span>
                <span>{{ ticket.priority }}</span>
              </div>
              <div class="priority">
                <span style="font-weight: bold;">Tipo</span>
                <span>{{ ticket.type }}</span>
              </div>
              <div class="priority step" @click="clickStep(ticket)">
                <span style="font-weight: bold;">Etapa</span>
                <span class="name-step">{{ ticket.step }}</span>
              </div>
              <div class="priority">
                <span style="font-weight: bold;">Desenvolvedor</span>
                <span>{{ ticket.programmer }}</span>
              </div>
              <!-- <div class="priority">
              <span style="font-weight: bold;">Progresso</span>
              <vs-progress :height="12" :percent="40" color="success">success</vs-progress>
              </div>-->
            </div>
            <div class="container-info">
              <div class="title">
                <span>
                  <a
                    style="text-decoration: underline;color:#147dbf"
                    target="blank"
                    :href="'http://www6.novotempo.com/glpi/front/ticket.form.php?id='+ticket.ticketId"
                  >{{ticket.ticketId}}</a>
                  -
                  {{ ticket.title }}
                </span>
              </div>
              <div class="description" v-html="ticket.description"></div>
            </div>
          </div>
          <div slot="footer" style="height:50px;margin-top: 10px;">
            <vs-row vs-justify="flex-end">
              <div class="icon-notification">
                <div class="icon-acompanhamento" @click.prevent="clickAcompanhamento(ticket)">
                  <!-- <div class="icon-count acompanha">2</div> -->
                  <a class="tooltips">
                    <img src="@/assets/acompanhamento.png" width="25px" />
                    <span>Acompanhamentos</span>
                  </a>
                </div>
                <div class="icon-tarefa" @click.prevent="clickTarefa(ticket)">
                  <!-- <div class="icon-count">2</div> -->
                  <a class="tooltips">
                    <img src="@/assets/tarefa.png" width="25px" />
                    <span>Tarefas</span>
                  </a>
                </div>
              </div>
            </vs-row>
          </div>
        </vs-card>
      </div>
    </div>
    <div class="load-more-glpi" v-if="ticketData.length > 0">
      <!-- <vs-button
        v-if="visibleLoad"
        color="primary"
        type="border"
        @click="clickLoadRefresh"
        icon="refresh"
      >Carregar mais...</vs-button>-->
    </div>
    <!-- poupap de acompanhamento -->
    <vs-popup title="Acompanhamentos" :active.sync="popupAcompanhamento">
      <vs-list>
        <vs-list-item
          v-for="(acompa, index) in acompanhamentoData"
          :key="index"
          class="list-acompanhamento"
        >
          <template slot="avatar">
            <div class="avatar-glpi">
              <vs-avatar size="45px" />
              <div style="text-align: center;">{{ acompa.login }}</div>
              <div style="text-align: center;">{{ acompa.dateFormat }}</div>
            </div>
          </template>
          <template slot="subtitle">
            <div class="text-acompanhamento" v-html="acompa.content"></div>
          </template>
        </vs-list-item>
      </vs-list>
    </vs-popup>
    <!-- fim -->
    <!-- poupap de tarefa -->
    <vs-popup title="Tarefas" :active.sync="popupTarefa">
      <vs-list>
        <vs-list-item
          v-for="(tarefa, index) in tarefaData"
          :key="index"
          class="list-acompanhamento"
        >
          <template slot="avatar">
            <div class="avatar-glpi">
              <vs-avatar size="45px" />
              <div style="text-align: center;">{{ tarefa.login }}</div>
              <div style="text-align: center;">{{ tarefa.dateFormat }}</div>
            </div>
          </template>
          <template slot="subtitle">
            <div class="text-acompanhamento" v-html="tarefa.content"></div>
          </template>
        </vs-list-item>
      </vs-list>
    </vs-popup>
    <!-- fim -->
    <!-- informações da etapa do glpi -->
    <vs-popup class="holamundo" title="Passos para conclusão do chamado" :active.sync="popupStep">
      <div>
        <div class="step-info">
          <div :class="selectedTicket.step == 'Fila Geral' ? 'selected-step' : ''">
            <span>
              <b>Fila Geral</b> - Entrada do chamado confirmado no departamento.
            </span>
          </div>
          <div :class="selectedTicket.step == 'Suporte' ? 'selected-step' : ''">
            <span>
              <b>Suporte</b> - Chamado em pré-atendimento.
            </span>
          </div>
          <div :class="selectedTicket.step == 'Análise' ? 'selected-step' : ''">
            <span>
              <b>Análise</b> - Chamado em fase de levantamento de requisitos com o requerente.
            </span>
          </div>
          <div :class="selectedTicket.step == 'Definição' ? 'selected-step' : ''">
            <span>
              <b>Definição</b> - Chamado aguardando um desenvolvedor disponível.
            </span>
          </div>
          <div :class="selectedTicket.step == 'Implementação' ? 'selected-step' : ''">
            <span>
              <b>Implementação</b> - Chamado em processo de implementação da solicitação.
            </span>
          </div>
          <div :class="selectedTicket.step == 'Teste' ? 'selected-step' : ''">
            <span>
              <b>Teste</b> - Chamado em fase de homologação da implementação efetuada.
            </span>
          </div>
          <div :class="selectedTicket.step == 'Concluído' ? 'selected-step' : ''">
            <span>
              <b>Finalizado</b> - Chamado concluído e estará disponível na próxima versão.
            </span>
          </div>
          <div :class="selectedTicket.step == 'Concluído(REVISÃO)' ? 'selected-step' : ''">
            <span>
              <b>Concluído Revisão</b> - Chamado reaberto pelo requerente por não atender ao especificado.
            </span>
          </div>
          <div :class="selectedTicket.step == 'Pendente' ? 'selected-step' : ''">
            <span>
              <b>Pendente</b> - Chamado aguardando retorno do requerente.
            </span>
          </div>
        </div>
      </div>
    </vs-popup>
    <!-- fim -->
  </div>
</template>

<script>
/* eslint-disable */
import axios from "axios";
import { baseApiUrlRH } from "@/global";

import PageTitle from "@/components/template/PageTitle";
import Login from "@/components/auth/Login";

import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

const configMessage = {
  iconPack: "fontawesome",
  position: "top-center",
  className: ["toast-global"],
  type: "error",
  duration: 5000
};

const configMessageYes = {
  iconPack: "fontawesome",
  position: "top-center",
  className: ["toast-global"],
  type: "success",
  duration: 3000
};

export default {
  name: "GLPI",
  components: { PageTitle, vSelect },
  data() {
    return {
      ticketData: [],
      acompanhamentoData: [],
      tarefaData: [],
      popupAcompanhamento: false,
      popupTarefa: false,
      page: 0,
      valueGroup: "",
      requerente: "",
      groupData: [],
      rowTypeData: [],
      workerData: [],
      step: "",
      loading: false,
      visibleLoad: true,
      glpi: "",
      developer: "",
      selectedGroup: null,
      visibleGroup: false,
      valueGroup: "",
      totalGlpiListed: 0,
      totalGeral: 0,
      popupStep: false,
      selectedTicket: {}
    };
  },
  computed: {
    filterList() {
      return this.groupData.filter(group => {
        return group.pathName
          .toLowerCase()
          .includes(this.valueGroup.toLowerCase());
      });
    }
  },

  methods: {
    async listGroups() {
      await axios
        .get(`${baseApiUrlRH}/queuegeneraluser/groups`)
        .then(resp => {
          console.log(resp.data);
          this.groupData = resp.data;
        })
        .catch(error => {});
    },

    clickItemGroup(group) {
      this.selectedGroup = group.id;
      this.valueGroup = group.pathName;
      this.visibleGroup = false;
    },
    onFocusGroup() {
      this.visibleGroup = true;
    },

    clickCloseGroup() {
      this.visibleGroup = !this.visibleGroup;
    },

    setSelected(value) {
      this.selectedGroup = value;
      this.valueGroup = value.id;
    },

    async listRowType() {
      await axios
        .get(`${baseApiUrlRH}/queuegeneraluser/rowtype`)
        .then(resp => {
          let newRowType = resp.data.map(rowtype => {
            return {
              text: rowtype.name,
              value: rowtype.id
            };
          });

          this.rowTypeData = [...new Set(newRowType)];
        })
        .catch(error => {});
    },

    async listWorker() {
      await axios
        .get(`${baseApiUrlRH}/queuegeneraluser/worker`)
        .then(resp => {
          let newWorker = resp.data.map(worker => {
            return {
              text: worker.fullName,
              value: worker.id
            };
          });

          this.workerData = [...new Set(newWorker)];
        })
        .catch(error => {});
    },

    async listTickets() {
      console.log("passou aqui");
      const userId = sessionStorage.getItem("@userId");
      this.$vs.loading({ text: "Carregando Chamados" });
      await axios
        .get(`${baseApiUrlRH}/queuegeneraluser/${userId}`)
        .then(resp => {
          resp.data.forEach(glpi => {
            this.totalGeral = glpi.total;
            this.ticketData.push(glpi);
          });

          let listVisible = resp.data.filter(glpi => glpi.isVisible);
          this.totalGlpiListed = listVisible.length;
        })
        .catch(error => {
          this.$vs.loading.close();
        });
      this.$vs.loading.close();
    },
    clickStep(ticket) {
      this.popupStep = true;
      this.selectedTicket = ticket;
    },
    async clickAcompanhamento(ticket) {
      const userId = sessionStorage.getItem("@userId");
      await axios
        .get(
          `${baseApiUrlRH}/queuegeneraluser/acompanhamento/${ticket.ticketId}/${userId}`
        )
        .then(resp => {
          this.acompanhamentoData = resp.data;
          if (this.acompanhamentoData.length <= 0) {
            this.$toasted.show(
              "Ainda não existem acompanhamentos para esse glpi!",
              configMessage
            );
          } else {
            this.popupAcompanhamento = true;
          }
        })
        .catch(error => {});
    },
    async clickTarefa(ticket) {
      const userId = sessionStorage.getItem("@userId");
      await axios
        .get(
          `${baseApiUrlRH}/queuegeneraluser/tarefa/${ticket.ticketId}/${userId}`
        )
        .then(resp => {
          this.tarefaData = resp.data;
          if (this.tarefaData.length <= 0) {
            this.$toasted.show(
              "Ainda não existem tarefas para esse glpi!",
              configMessage
            );
          } else {
            this.popupTarefa = true;
          }
        })
        .catch(error => {});
    },
    ClickClear() {
      this.glpi = "";
      this.step = "";
      this.requerente = "";
      this.valueGroup = "";
      this.developer = "";
      this.visibleLoad = false;
      this.selectedGroup = null;
      this.visibleGroup = false;
      this.valueGroup = "";
    },
    async clickSearch() {
      console.log(
        "variaveis",
        this.glpi,
        this.requerente,
        this.valueGroup,
        this.step,
        this.developer
      );

      if (
        this.glpi == "" &&
        this.requerente == "" &&
        this.valueGroup == "" &&
        this.step == "" &&
        this.developer == ""
      ) {
        this.ticketData = [];
        this.listTickets();
        return;
      }

      const search = {
        glpi: this.glpi,
        rowType: this.step,
        requerente: this.requerente,
        groupRequerente: this.selectedGroup,
        userId: this.developer
      };

      this.loading = true;
      this.visibleLoad = false;
      this.ticketData = [];

      console.log(search);

      const userId = sessionStorage.getItem("@userId");

      await axios
        .post(`${baseApiUrlRH}/queuegeneraluser/search/${userId}`, search)
        .then(resp => {
          console.log(resp.data);
          this.ticketData = resp.data;

          let listVisible = resp.data.filter(glpi => glpi.isVisible);
          this.totalGlpiListed = listVisible.length;
        })
        .catch(error => {
          this.loading = false;
          console.log(error);
        });
      this.loading = false;
    },
    clickLoadRefresh() {
      this.page += 10;
      this.listTickets();
    }
  },
  mounted() {},
  created() {
    this.listTickets();
    this.listGroups();
    this.listRowType();
    this.listWorker();
  }
};
</script>

<style scoped  src="./style.css"></style>
